export enum CornerPositionEnum {
    topLeft,
    topRight,
    bottomLeft,
    bottomRight,
    box
}
